import { ICategoryApiModel, ICategoryImageUploadApiModel } from '../repositories/IStore.api';

export class CategoryModel implements CategoryModelProps {
  id: number;
  orderBy: number;
  name: string;
  url: string;
  productCount: number;
  description: string;
  localId?: number;
  enabled: boolean;
  isSampleCategory: boolean;
  image?: string;
  nueva?: number;
  parentId?: number;

  constructor(data: CategoryModelProps) {
    this.id = data.id;
    this.orderBy = data.orderBy;
    this.name = data.name;
    this.url = data.url;
    this.productCount = data.productCount;
    this.description = data.description;
    this.enabled = data.enabled;
    this.isSampleCategory = data.isSampleCategory;
    this.image = data.image;
    this.parentId = data.parentId;
  }

  static fromApi(data: ICategoryApiModel) {

    return ({
      id: data.id,
      orderBy: data.orderBy,
      name: data.name,
      url: data.url,
      productCount: data.productCount,
      description: data.description,
      enabled: data.enabled,
      parentId: data.parentId,
      isSampleCategory: data.isSampleCategory,
      image: (data.imageUrl) ? data.imageUrl : ''
    });
  }

  static empty() {
    return new CategoryModel({
      id: null,
      orderBy: null,
      name: null,
      url: null,
      productCount: null,
      description: null,
      enabled: null,
      isSampleCategory: null,
      parentId: null
    });
  }

  static fromApiUpload(data: ICategoryImageUploadApiModel) {
    return ({
      orderBy: data.orderBy,
      hdThumbnailUrl: data.hdThumbnailUrl,
      thumbnailUrl: data.thumbnailUrl,
      originalImageUrl: data.originalImageUrl,
      imageUrl: data.imageUrl,
      originalImage: data.originalImage,
      thumbnail: data.thumbnail,
      borderInfo: data.borderInfo,
      name: data.name,
      nameTranslated: data.nameTranslated,
      url: data.url,
      productCount: data.productCount,
      description: data.description,
      descriptionTranslated: data.descriptionTranslated,
      enabled: data.enabled,
      isSampleCategory: data.isSampleCategory,
      parentId: data.parentId
    });
  }

}

export interface CategoryModelProps {
  id: number;
  orderBy: number;
  name: string;
  url: string;
  productCount: number;
  description: string;
  localId?: number;
  enabled: boolean;
  isSampleCategory: boolean;
  image?: string;
  parentId?: number;
}
